import React, { useState } from "react";
import {
  required,
  TextInput,
  useNotify,
  useRefresh,
  SelectInput,
  FormDataConsumer,
} from "react-admin";
import { useForm, FormProvider } from "react-hook-form";
import { getPageId } from "../../helpers/getPageId";
import AutoCompleteDescription from "./AutoCompleteDescription";
import QuantityInput from "./QuantityInput";
import CombineDescriptionWithQuantity from "./CombineDescriptionWithQuantity";
import { ORDER_ITEM_NEW, ORDER_ITEM_PAID } from "../Constant";
import TextInputNoWheel from "../Common/TextInputNoWheel";
import Button from "@mui/material/Button";
import { postWithLogger } from "../../helpers/fetchHandleError";
import { getCookie } from "../../helpers/Cookies";

const choices = [ORDER_ITEM_NEW, ORDER_ITEM_PAID].map((c) => ({
  id: c,
  name: c,
}));

const CreateOrderItemByFreeText = ({ currency, orderId, onClose }) => {
  const pageId = getPageId();
  const refresh = useRefresh();
  const notify = useNotify();
  const [isLoading, setIsLoading] = useState(false);

  const formMethods = useForm({
    defaultValues: {
      page: pageId,
      order: orderId,
      currencyCode: currency,
      status: ORDER_ITEM_NEW,
    },
  });

  const handleSubmit = async ({ item, ...values }) => {
    setIsLoading(true);
    const token = getCookie("token");
    postWithLogger(`${process.env.REACT_APP_CMS_HOST}/orderitems`, {
      arg: values,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then(() => {
        setIsLoading(false);
        notify(`Order item created`, "info");
        refresh();
        onClose();
      })
      .catch((error) => {
        setIsLoading(false);
        notify(error.message, "error");
      });
  };

  return (
    <form className="form" onSubmit={formMethods.handleSubmit(handleSubmit)}>
      <FormProvider {...formMethods}>
        <>
          <AutoCompleteDescription />
          <br />
          <span style={{ color: "red" }}>
            *No need to put quantity in item description
          </span>
          <br />
          <QuantityInput />
          <CombineDescriptionWithQuantity />
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <>
                  <TextInputNoWheel
                    type="number"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(formData);
                      }
                    }}
                    source="price"
                    validate={required()}
                    fullWidth
                  />
                  <TextInputNoWheel
                    type="number"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(formData);
                      }
                    }}
                    source="weight"
                    validate={required()}
                    fullWidth
                    defaultValue={0}
                  />
                  <TextInputNoWheel
                    type="number"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(formData);
                      }
                    }}
                    source="cost"
                    validate={required()}
                    fullWidth
                    defaultValue={0}
                  />
                </>
              );
            }}
          </FormDataConsumer>
          <br />
          {/* <span style={{ color: "red" }}>
            *You can only edit these after item created
          </span> */}
          <SelectInput
            defaultValue={ORDER_ITEM_NEW}
            fullWidth
            source="status"
            choices={choices}
            validate={required()}
          />
          <TextInput readOnly source="currencyCode" />
          <div>
            <Button type="submit" variant="contained" disabled={isLoading}>
              Save
            </Button>
          </div>
        </>
      </FormProvider>
    </form>
  );
};

export default CreateOrderItemByFreeText;
